// reach_ui/src/components/VastGPT/ChatMessage.js
import React from 'react'
import DudeReadingV2Icon from '../theme/DudeReadingV2Icon'
import MarkdownWithEllipsis from './MarkdownWithEllipsis'
import ResponseMenu from './ResponseMenu'

const ChatMessage = ({
  message,
  given_name,
  family_name,
  loadingResponse,
  toolCallComponent,
}) => {
  if (message?.role === 'tool') {
    return null
  }

  let usedGivenName = given_name
  let usedFamilyName = family_name

  const messageName = message?.name?.replace(/[_-]/g, ' ')
  if (messageName) {
    usedGivenName = messageName?.split(' ')[0]
    usedFamilyName = messageName?.split(' ')[1]
  }

  return (
    <div className={`chat-message ${message?.role}`}>
      <div className={`avatar ${message?.role}`}>
        {message?.role === 'user' ? (
          `${usedGivenName?.slice(0, 1)}${usedFamilyName?.slice(0, 1)}`
        ) : (
          <DudeReadingV2Icon style={{ marginTop: 11, marginLeft: 4 }} />
        )}
      </div>
      <div className="content">
        <div className="role">
          {message?.role === 'assistant'
            ? 'VastGPT'
            : `${usedGivenName} ${usedFamilyName}`}
        </div>
        <div>
          {message?.role === 'assistant' ? (
            <>
              {typeof message?.content === 'string' ? (
                <MarkdownWithEllipsis
                  markdown={message.content}
                  loadingResponse={loadingResponse}
                />
              ) : null}
              {message?.tool_calls ? toolCallComponent(message) : null}
            </>
          ) : null}
          {message?.role === 'user' ? message?.content : null}
        </div>
      </div>
      {message?.role === 'assistant' && !message?.tool_calls && (
        <ResponseMenu />
      )}
    </div>
  )
}

export default ChatMessage
